import axios from 'axios';
import { useRouter } from 'vue-router';
import { inject } from 'vue';
import { logger } from '@/plugins/logger';

const LOGGER_TAG = 'api';

export default {
    install: (app, options) => {
        let url = import.meta.env.VITE_API_URL;
        let prefix = '/customer/api';

        if (!url) {
            // prendi l'indirizzo corrente e togli il dominio di terzo livello
            url = window.location.href;
            let protocol = url.split('/')[0];

            // prendi il dominio dall'url
            let domain = url.split('/')[2];
            let domainParts = domain.split('.');
            let domainLength = domainParts.length;
            if (domainLength == 3) {
                url = domainParts[1] + '.' + domainParts[2] + prefix;
            } else {
                url = domainParts[0] + '.' + domainParts[1] + prefix;
            }
            url = protocol + '//' + url;
            logger.info(LOGGER_TAG, 'url:', url);
        } else {
            url += prefix;
        }

        let axiosInstance = axios.create({
            baseURL: url,
            withCredentials: true,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        app.provide('api', axiosInstance);
    }
}

export const HttpCodes = {
    OK: 200,
    CREATED: 201,
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    UNPROCESSABLE_ENTITY: 422,
    INTERNAL_SERVER_ERROR: 500
};

export function useApi() {
    const api = inject('api');
    const router = useRouter();

    if (!api) {
        throw new Error('API not provided. Something went wrong during plugin installation.');
    }

    api.interceptors.response.use((response) => {
        if (response.data.redirect) {
            window.location.href = response.data.url;
            return;
        }

        return response;
    }, (error) => {
        let code = error.code;
        if ((code == 'ERR_NETWORK' || [401].includes(error.status)) && window.location.pathname !== '/not-found') {
            router.push('/not-found');
        }
        return Promise.reject(error);
    });
    return api;
}